<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">总部发货单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsDetail">
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            @change="getDeviceList"
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="deviceList != ''">
          <a-select v-model="type" style="width:120px">
            <a-select-option :value="1">调货网点</a-select-option>
            <a-select-option :value="2">收货网点</a-select-option>
          </a-select>
          <a-select
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            style="width:200px;margin-left:10px"
            placeholder="请选择网点设备"
            v-model="deviceID"
          >
            <a-select-option
              v-for="(item, i) in deviceList"
              :key="i"
              :value="item.device_id"
              >{{ item.device_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>状态：</label>
          <a-select v-model="status" style="width:120px">
            <a-select-option :value="1">待收货</a-select-option>
            <a-select-option :value="2">无差异入库</a-select-option>
            <a-select-option :value="3">待管理介入</a-select-option>
            <a-select-option :value="4">管理通过</a-select-option>
            <a-select-option :value="5">管理驳回</a-select-option>
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="单号|网点名称|员工姓名|员工手机号"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <label>出库日期：</label>
          <a-range-picker
            v-model="dateVal"
            @change="selectDate"
            :ranges="{
              今天: [moment(), moment()],
              本月: [moment().startOf('month'), moment()],
              上月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
              ]
            }"
          />
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadMachineIn">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.out_date }}</td>
              <td>{{ item.device_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.express }}</td>
              <td>
                <p v-show="item.status == 1">待收货</p>
                <p v-show="item.status == 2">无差异入库</p>
                <p v-show="item.status == 3">待管理介入</p>
                <p v-show="item.status == 4">管理通过</p>
                <p v-show="item.status == 5">管理驳回</p>
              </td>
              <td class="operation">
                <a @click="editExpress(item)" style="color:#67c23a">编辑单号</a>
                <a @click="detailPage(item)" style="color:#666">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 详情 -->
    <machineInDetail
      v-show="showIsDetail"
      :detailVal="detailVal"
      v-on:hideIsDetail="hideIsDetail"
    />
    <!-- 详情 end -->
    <!-- 编辑单号 -->
    <aside class="dialogsBox" v-show="showIsExpress">
      <div>
        <h2>修改单号</h2>
        <a class="close" @click="closeExpress"><a-icon type="close-circle"/></a>
        <ul>
          <li>
            <label>项目名称：</label>
            <p>{{ expressDetail.project_name }}</p>
          </li>
          <li>
            <label>网点名称：</label>
            <p>{{ expressDetail.device_name }}</p>
          </li>
          <li>
            <label>发货日期：</label>
            <p>{{ expressDetail.out_date }}</p>
          </li>
          <li>
            <label>物流单号：</label>
            <a-input
              style="width:200px"
              v-model="express"
              placeholder="请输入物流单号"
            />
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitExpress">提交</a-button>
        </div>
      </div>
    </aside>
    <!-- 编辑单号 end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import machineInDetail from "@/components/equipment/machineInDetail";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "出库时间",
        "网点名称",
        "网点员工",
        "物流单号",
        "状态",
        "操作"
      ],
      proList: [],
      showIsDetail: false,
      detailVal: "",
      status: "",
      project_id: "",
      device_id: "",
      collect_device_id: "",
      user_id: "",
      type: 1,
      deviceID: "",
      deviceList: [],
      query_field: "",
      showIsExpress: false,
      expressDetail: "",
      express: "",
      dateVal: null,
      start_date: "",
      end_date: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    machineInDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro();
  },
  methods: {
    moment,
    selectDate(dates, dateStrings) {
      this.start_date = dateStrings[0];
      this.end_date = dateStrings[1];
    },
    downloadMachineIn() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_out_order/listsDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&project_id=" +
        this.project_id +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date +
        "&status=" +
        this.status;
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getDeviceList() {
      this.deviceID = "";
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/getListData";
      let params = {
        project_id: this.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          this.deviceList = res.data.data;
          // console.log(this.deviceList);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    backHref() {
      this.showIsDetail = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.status = "";
      this.type = 1;
      this.deviceID = "";
      this.project_id = "";
      this.device_id = "";
      this.collect_device_id = "";
      this.query_field = "";
      this.user_id = "";
      this.start_date = "";
      this.end_date = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_out_order/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        token: window.localStorage.getItem("xnwfPcToken"),
        status: this.status,
        query_field: this.query_field,
        project_id: this.project_id,
        device_id: this.type == 1 ? (this.device_id = this.deviceID) : "",
        collect_device_id:
          this.type == 2 ? (this.collect_device_id = this.deviceID) : "",
        start_date: this.start_date,
        end_date: this.end_date
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(item) {
      // console.log(this.detailVal);
      this.detailVal = item;
      this.showIsDetail = true;
    },
    hideIsDetail(msg) {
      this.showIsDetail = false;
      if (msg) {
        this.reload();
      }
    },
    editExpress(item) {
      this.express = item.express;
      this.expressDetail = item;
      this.showIsExpress = true;
    },
    closeExpress() {
      this.showIsExpress = false;
    },
    submitExpress() {
      if (this.express != "") {
        this.showIsExpress = false;
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Project_out_order/setExpress";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_out_order_id: this.expressDetail.id,
          express: this.express
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("修改成功");
            this.reload();
          } else {
            this.$message.warning(res.data.message);
          }
        });
      } else {
        this.$message.error("请输入物流单号");
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
